// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "/chunks/WistiaEmbed" + "." + "16ce9d6f84dffe91ae22" + ".js";
};